import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchLeadProjectTypes = createAsyncThunk(
  "fetchLeadProjectTypes",
  async ({ page, limit }) => {
    const token = localStorage.getItem("auth_token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `category/list?page=${page}&limit=${limit}&category=leadProjectType`,
      config
    );

    return response.data.data;
  }
);

const LeadProjectTypeSlice = createSlice({
  name: "LeadProjectTypeSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchLeadProjectTypes.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchLeadProjectTypes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.currentPage;
      state.total = action.payload.total;
    });
    builder.addCase(fetchLeadProjectTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default LeadProjectTypeSlice.reducer;
